import {calendars} from './calendars';
import {changes} from './changes';
import {channels} from './channels';
import {combineReducers} from 'helpers';
import {events} from './events';
import {lastChangeTimestamp} from './last-change-timestamp';
import {progress} from './progress';
import {ready} from './ready';
import {syncTokens} from './sync-tokens';
import {user} from './user';

export const googleCalendar = combineReducers({ calendars, changes, channels, events, lastChangeTimestamp, progress, ready, syncTokens, user });
